var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('messages-page',{attrs:{"title":"Общая информация","messages-list":_vm.MESSAGES_INFO},on:{"read":_vm.read,"download":_vm.download}})}
var staticRenderFns = []

export { render, staticRenderFns }